import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomTableSmall from "../../unit/CustomTableSmall";

const DashboardSearchProduct = ({ ...props }) => {
  const searchResult = props.searchResult;
  return (
    <TableContainer sx={{ maxHeight: 440 }}>
      <CustomTableSmall
        key={"dashboardSearchProduct"}
        stickyHeader
        aria-label="sticky table"
        id="table-dashboard-search-products"
      >
        <TableHead>
          <TableRow>
            <TableCell className="hm-table-header">Product #</TableCell>
            <TableCell className="hm-table-header">Product Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {searchResult == undefined ||
          searchResult.length == 0 ||
          searchResult == null ? (
            <TableRow>
              <TableCell colSpan={8}>No Data </TableCell>
            </TableRow>
          ) : (
            searchResult?.map((item: any) => (
              <TableRow key={`dashboard_search_product_` + item.id}>
                <TableCell>{item.id}</TableCell>
                <TableCell>{item.sProductName}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </CustomTableSmall>
    </TableContainer>
  );
};
export default DashboardSearchProduct;
